/**
 * Excludes Next.js telemetry from the given envelope.
 *
 * @param envelope The telemetry envelope to process.
 * @returns A boolean indicating whether the telemetry should be excluded.
 */
export const excludeNextjsTelemetryprocessor = envelope => {
  // Next.js telemetry always contains this property
  if ('next.span_type' in envelope.data.baseData?.properties) {
    return false;
  }
  return true;
};
//# sourceMappingURL=excludeNextjsTelemetryprocessor.js.map